import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import product_img1 from '../Assets/Images/product_img1.jpg';
import product_img2 from '../Assets/Images/product_img2.jpg';

import { useNavigate } from "react-router-dom";

const FeaProduct_main = () => {

  // ✅ FIX: Hook component ke andar
  const navigate = useNavigate();

  const products = [
    {
      id: 1,
      title: "Light N Care Anti Blemish Cream – Ayurvedic Formula...",
      subtitle: "{title}",
      originalPrice: "1200",
      salePrice: "899.00",
      badge: "Sale",
      img: product_img1,
    },
    {
      id: 2,
      title: "Light N Care Super Bright Facewash...",
      subtitle: "{title}",
      originalPrice: "399",
      salePrice: "299.00",
      badge: "Sale",
      img: product_img2,
    },
  ];

  return (
    <div className="featuredProduct_sec">
      <Container>

        <Row>
          <Col lg={12}>
            <div className="heading">
              <h2>Featured Products</h2>
            </div>
          </Col>
        </Row>

        <Row>
          {products.map((product) => (
            <Col lg={4} md={6} sm={12} key={product.id} className="mb-4">

              <div className="product_card">

                <div className="card_image">
                  <img src={product.img} alt="img" className="img_main" />
                  <img src={product.img} alt="img" className="img_clone" />
                </div>

                <div className="sale_badge">{product.badge}</div>

                <div className="card_content">
                  <h3 className="product_title">{product.title}</h3>
                  <p className="product_subtitle">{product.subtitle}</p>

                  <div className="price_block">
                    <span className="original_price">
                      Rs. {product.originalPrice}
                    </span>
                    <span className="sale_price">
                      Rs. {product.salePrice}
                    </span>
                  </div>

                  <button
                    className="add_to_cart_btn"
                    onClick={() => navigate("/card")}
                  >
                    Add to cart
                  </button>
                </div>

              </div>

            </Col>
          ))}
        </Row>

      </Container>
    </div>
  );
};

export default FeaProduct_main;